const PesquisasSatisfacaoHome = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../_views/PesquisasSatisfacaoHome')
const CadastroPesquisaSatisfacao = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../_views/CadastroPesquisaSatisfacao')
const AtualizarPesquisaSatisfacao = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../_views/AtualizarPesquisaSatisfacao')

import { permissoesCadastroPesquisa } from '../../../../../utils/permissoesPesquisaSatisfacao'

export default [
  {
    path: 'pesquisa-satisfacao',
    component: PesquisasSatisfacaoHome,
    meta: { requiresAuth: true, permissions: [...permissoesCadastroPesquisa] },
    name: 'cadastroPesquisa',
  },
  {
    path: 'pesquisa-satisfacao/criar',
    component: CadastroPesquisaSatisfacao,
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_TOTAL],
    },
    name: 'cadastroPesquisa/criar',
  },
  {
    path: 'pesquisa-satisfacao/atualizar/:_id',
    component: AtualizarPesquisaSatisfacao,
    meta: { requiresAuth: true, permissions: [...permissoesCadastroPesquisa] },
    name: 'cadastroPesquisa/atualizar',
    props: true,
  },
]
